var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCoinHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddn_1987_18846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.454 67.0014C134.454 103.151 105.149 132.456 68.9995 132.456C32.8499 132.456 3.54492 103.151 3.54492 67.0014C3.54492 30.8519 32.8499 1.54688 68.9995 1.54688C105.149 1.54688 134.454 30.8519 134.454 67.0014Z",
    stroke: "#005754",
    strokeWidth: 5.31071,
    strokeDasharray: "10.62 10.62",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iin_1987_18846)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.5456,
    cy: 66.5359,
    r: 60.1438,
    transform: "rotate(180 68.5456 66.5359)",
    fill: "#005754"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_in_1987_18846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3213 76.4978H37.998V58.8236H69.6982V76.4978H99.1055V56.6172",
    stroke: "#00CEC8",
    strokeWidth: 4.39634
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddn_1987_18846",
    x: 0.93382,
    y: 0.661756,
    width: 135.865,
    height: 135.863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.354048,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1987_18846"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.132768,
    dy: 1.59321
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.06214
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1987_18846"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.354048,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1987_18846"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.132768,
    dy: 0.531071
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.265536
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1987_18846",
    result: "effect2_dropShadow_1987_18846"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "7.5319428443908691 7.5319428443908691",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 2402
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.08)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_1987_18846"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect3_noise_1987_18846",
    in2: "effect2_dropShadow_1987_18846",
    result: "effect3_noise_1987_18846"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iin_1987_18846",
    x: 8.40234,
    y: 5.32848,
    width: 120.685,
    height: 122.944,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.398304,
    dy: 1.59321
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.59321
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1987_18846"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.06214
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.59321
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1987_18846",
    result: "effect2_innerShadow_1987_18846"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "7.5319428443908691 7.5319428443908691",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect2_innerShadow_1987_18846",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(33, 33, 41, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_1987_18846"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect2_innerShadow_1987_18846"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_in_1987_18846",
    x: 35.8008,
    y: 56.6172,
    width: 65.502,
    height: 22.3437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.265536
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.57754
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1987_18846"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "7.5319428443908691 7.5319428443908691",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_innerShadow_1987_18846",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(179, 40, 33, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_1987_18846"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_innerShadow_1987_18846"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCoinHead);
export default __webpack_public_path__ + "static/media/green-coin-head.531478dc9b0ebabe370074ade82984d1.svg";
export { ForwardRef as ReactComponent };